import { Divider } from '@mui/material';

import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

export const EditSurchargesMaintenanceSkeleton = () => (
  <>
    <SectionSkeleton height={100} />
    <Divider />
    <SectionSkeleton height={500} />
  </>
);
